import type {
  IProjectFormData,
  IProjectTableColumnDefinition,
  ProjectTableColumnKey,
  ProjectToolbarControlKey,
  StatusFilter,
} from "./types";
import { RaasProjectListBackendStatus } from "./status";

export const ITEMS_PER_PAGE = 10;
export const MAX_VISIBLE_PAGE_BUTTONS = 5;
export const MAX_PRESENTATION_CANDIDATE_BATCH = 5;
export const PAGINATION_ELLIPSIS = -1;
export const PROJECT_TABLE_SCROLL_GUTTER = 32;
export const ALL_CLIENTS_FILTER_VALUE = "all";
export const ALL_ASSIGNEES_FILTER_VALUE = "all";

export const DEFAULT_FORM: IProjectFormData = {
  project_name: "",
  job_title: "",
  acting_user_id: "",
  client_name: "",
  client_company_id: "",
  client_company_account_id: "",
  client_domain: "",
  hiring_company_name: "",
  hiring_company_id: "",
};

export const STATUS_FILTER_OPTIONS: Array<{
  label: string;
  value: StatusFilter;
}> = [
  { label: "All statuses", value: "all" },
  { label: "Submitted to Client", value: "submitted_to_client" },
  { label: "In Progress", value: "in_progress" },
  { label: "Approved", value: "completed" },
  { label: "Not Started", value: "not_started" },
];

export const STATUS_FILTER_TO_API: Record<Exclude<StatusFilter, "all">, RaasProjectListBackendStatus> = {
  in_progress: RaasProjectListBackendStatus.InProgress,
  completed: RaasProjectListBackendStatus.Completed,
  submitted_to_client: RaasProjectListBackendStatus.SubmittedToClient,
  not_started: RaasProjectListBackendStatus.NotStarted,
};

export const PROJECT_TABLE_COLUMN_DEFINITIONS: Record<
  ProjectTableColumnKey,
  IProjectTableColumnDefinition
> = {
  project: { key: "project", label: "Project", width: 420 },
  client: { key: "client", label: "Client", width: 150 },
  acting_user_id: { key: "acting_user_id", label: "Assigned To", width: 180 },
  hiring_for: { key: "hiring_for", label: "Hiring for", width: 150 },
  milestone: { key: "milestone", label: "Milestone", width: 150 },
  status: { key: "status", label: "Status", width: 160 },
  pipeline: { key: "pipeline", label: "Pipeline", width: 80 },
  updated_at: { key: "updated_at", label: "Last Updated", width: 100 },
  actions: { key: "actions", label: "", width: 32 },
};

export const PROJECT_TOOLBAR_CONTROL_PLACEMENT: Record<
  ProjectToolbarControlKey,
  "left" | "right"
> = {
  search: "left",
  status_filter: "left",
  org_selector: "right",
  impersonation_selector: "right",
  client_filter: "right",
  assigned_to_filter: "right",
  create_project: "right",
  upload_template: "right",
};

export const SUBMITTED_STATUS_VALUES = new Set([
  "submitted",
  "submitted_to_client",
  "sent_to_client",
  "client_submitted",
]);

export const CURRENT_USER_COMPANY_META_REF_KEYS = [
  "company_meta_ref",
  "companyMetaRef",
  "company_id",
  "companyId",
  "company_ref",
  "companyRef",
  "fm_company_id",
  "findem_company_id",
] as const;

export const PROJECT_CLIENT_COMPANY_META_REF_KEYS = [
  "client_meta_ref",
  "clientMetaRef",
  "client_company_meta_ref",
  "clientCompanyMetaRef",
  "account_company_meta_ref",
  "accountCompanyMetaRef",
  "account_company_id",
  "accountCompanyId",
  "company_meta_ref",
  "companyMetaRef",
  "company_id",
  "companyId",
  "company_ref",
  "companyRef",
  "fm_company_id",
  "findem_company_id",
] as const;
